import Vue from 'vue';
import Vuex from 'vuex';
import api from '../plugins/api';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		languages: [
			'ru',
			'kaz'
		],
		activeLng: 'ru',
		translates: {},

		pagesData: {
			step1: {},
			step2: {}
		},

		documentsData: {},
		documentsPageStatus: false,
		documentsPageNow: 0,
		activeLink: 0,
		counter: {
			count: 0,
			people: 0,
			related: 0,
			affiliate: 0,
			bailiffs: 0,
			judges: 0,
			lawyers: 0,
			notaries: 0,
			prosecutors: 0,
			individuals: 0,
			legal_entity: 0
		},
		step: 1
	},

	getters: {
		FULLTRANSLATES: state => {
			return state.translates;
		},

		TRANSLATES: state => {
			return state.translates[state.activeLng];
		},

		LANGUAGES: state => {
			return state.languages;
		},

		ACTIVE_LANGUAGE: state => {
			return state.activeLng;
		},

		PAGE: (state) => (page) => {
			return state.pagesData[page];
		},

		GET_ACTIVE_LINK: (state) => {
			return state.activeLink;
		},

		GET_COUNTER: (state) => (key) => {
			return state.counter[key];
		},

		GET_STEP: (state) => {
			return state.step;
		}
	},

	mutations: {
		CHANGE_LANGUAGE: (state, payload) => {
			state.activeLng = payload;
		},

		SET_TRANSLATES: (state, payload) => {
			state.translates = payload;
		},

		SET_PAGE: (state, payload) => {
			state.pagesData[payload.page] = Object.assign({}, state.pagesData[payload.page], payload.data);
		},

		SET_ACTIVE_LINK: (state, payload) => {
			state.activeLink = payload;
		},

		SET_COUNTER: (state, payload) => {
			state.counter = payload;
		},

		SET_STEP: (state, payload) => {
			state.step = payload;
		}
	},

	actions: {
		CHANGE_LANGUAGE: (context, payload) => {
			context.commit('CHANGE_LANGUAGE', payload);
		},

		GET_TRANSLATES: async (context) => {
			return api.get('translates').then((resp) => {
				context.commit('SET_TRANSLATES', resp.data.translates);
			});
		},

		GET_HOME: async (context, data = {}) => {
			return api.get('home', {
				params: data
			}).then((resp) => {
				context.commit('SET_COUNTER', resp.data);
			});
		},

		SET_ACTIVE_LINK: (context, payload) => {
			context.commit('SET_ACTIVE_LINK', payload);
		},

		SET_STEP: (context, payload) => {
			context.commit('SET_STEP', payload);
		},

		SET_PAGE: (context, payload) => {
			context.commit('SET_PAGE', payload);
		}
	}
});

export default store;
